export default {
    config: {
        colorPalete: [
            [219, 206, 174],
            [214, 151, 145],
            [240, 189, 255],
            [177, 255, 246],
            [160, 204, 96]
        ],
        contrastThreshold: 1.4
    },
    colorLetterMap: {},
    luminanace(r, g, b) {
        let a = [r, g, b].map(function (v) {
            v /= 255;
            return v <= 0.03928 ? v / 12.92 : Math.pow( (v + 0.055) / 1.055, 2.4 );
        });
        return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
    },
    contrastWhite(rgb) {
        let result = 1.05 / (this.luminanace(rgb[0], rgb[1], rgb[2]) + 0.05);
        return result;
    },
    contrastBlack(rgb) {
        let result =  (this.luminanace(rgb[0], rgb[1], rgb[2]) + 0.05) / 0.05;
        return result; 
    },
    contrast(rgb1, rgb2) {
        let result = (this.luminanace(rgb1[0], rgb1[1], rgb1[2]) + 0.05) / (this.luminanace(rgb2[0], rgb2[1], rgb2[2]) + 0.05);
        if (result < 1)  {
            result = 1/result; 
          return result; 
        }
    },
    generateColor(r, g, b) {
        let red = Math.floor((Math.random() * 256) + 1);
        let green = Math.floor((Math.random() * 256) + 1);
        let blue = Math.floor((Math.random() * 256) + 1);
        
        red = (red + r) / 2;
        green = (green + g) / 2;
        blue = (blue + b) / 2;
        
        return [ Math.round(red), Math.round(green), Math.round(blue)];  
    },
    getNextWhiteFont(attempts) {
        
        let index = Math.floor((Math.random() * this.config.colorPalete.length));
        let rgb = this.config.colorPalete[index];
        
        let crtRgb =  this.generateColor(rgb[0], rgb[1], rgb[2]);
        let contrast = this.contrastWhite(crtRgb);
        
        if(attempts >= 2)
            return crtRgb;

        if(contrast <= 1.4) {
            attempts = attempts ? attempts + 1 : 1;
            return this.getNextWhiteFont(attempts)
        }

        return crtRgb;
    },
    getNextBlackFont(attempts) {
        let index = Math.floor((Math.random() * this.config.colorPalete.length));
        let rgb = this.config.colorPalete[index];
        let crtRgb = this.generateColor(rgb[0], rgb[1], rgb[2]);
        
        let contrast = this.contrastBlack(crtRgb);
        if(attempts >= 2)
            return crtRgb;

        if(contrast <= 1.4) {
            attempts = attempts ? attempts + 1 : 1;
            return this.getNextBlackFont(attempts)
        }

        return crtRgb;
    },
    getNextWhiteFontRGB(letter) {
        
        if(letter || letter.length > 0) {
            if(this.colorLetterMap[letter]) {
                let rgb = this.colorLetterMap[letter];
                return 'rgb(' + rgb[0] + ', ' +  rgb[1] + ', '  +  rgb[2] + ')' ;
            }
        }

        let rgb = this.getNextWhiteFont();
        if(letter || letter.length > 0) { 
            this.colorLetterMap[letter] = rgb;
        }
        return 'rgb(' + rgb[0] + ', ' +  rgb[1] + ', '  +  rgb[2] + ')' ;
    }
}